import { versatileCardFields } from '@/providers/contentful';

export const partnerInfoQuery = `query PartnerInfoQuery($opco: String!, $market: String!, $locale: String!) {
  microcopyCollection(locale: $locale, where: {
    key_in: [
      "merchant.pageTitle"
      "merchant.titleHeading"
      "merchant.ratewas"
      "merchant.whatYouNeedToKnow"
      "termsandconditions.label"
      "termsandconditions.backToTop"
      "merchant.about"
      "purchasehistory.avios"
      "mechanic.tab.title.estore"
      "mechanic.tab.title.clo"
      "mechanic.tab.title.manual"
      "mechanic.tab.title.convert"
      "merchant.error.title"
      "merchant.collect"
      "merchant.error.message"
      "general.closeLabel"
      "speedyAward.title"
      "favourites.button.addToFavourites"
      "favourites.button.addedToFavourites"
      "favourites.button.removeFromFavourites"
      "favourites.button.removedFromFavourites"
      "pagePartner.aviosTimeline.headline"
      "pagePartner.aviosTimeline.purchased"
      "pagePartner.aviosTimeline.awarded"
      "pagePartner.aviosTimeline.moreInfoLabel"
      "general.time.today"
      "general.time.days"
      "general.time.hours"
      "general.status.inPending"
      "general.within"
      "shopNow.loggedOutCtaLabel"
    ]
  }) {
    items {
      key
      value
    }
  }
  pagePartnerCollection(where: {market: $market, opco: $opco}) {
    items {
      aviosTimelineInfoModal {
        ...versatileCardFields
      }
    }
  }
}
${versatileCardFields}`;
